import { render } from "./WhatsappFloat-component.vue?vue&type=template&id=cac10630"
import script from "./WhatsappFloat-component.vue?vue&type=script&lang=js"
export * from "./WhatsappFloat-component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__